/* src/app/core/modules/shared/components/popover-tooltip/popover-tooltip.component.scss */
/*# sourceMappingURL=/avvera/dev/popover-tooltip.component.css.map */
